import { PlusOutlined } from "@ant-design/icons";
import { Col, Divider, Flex, Modal, Row, Space, Button } from "antd";
import { CardContainer } from "components/elements";
import { Input, InputNumber, RadioGroup, Select } from "components/form";
import EmployeeInfoEducationTable from "components/table/EmployeeInfoEducationTable";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import schema, {
  initialValues as INITIAL_VAUES,
} from "../schemas/employeeInfoEducationSchema";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

function EmployeeInfoEducation({
  isLoading = false,
  initialValues = {},
  educationList = [],
  pagination = {},
  onSubmit = () => { },
  onEdit = () => { },
  onCancel = () => { },
  onCreate = () => { },
  onDelete = () => { },
  onChange = () => { },
  dataDetail = {},
  isModalOpen = false,
  setModalOpen = () => { },
  educationDegreeOptions = []
}) {
  console.log("dsdada", dataDetail);
  const { t } = useTranslation();
  const educationDegree = useSelector((state) => state.options.educationDegreeOptions)
  const { roles } = useSelector((state) => state.company);
  // console.log("test", educationDegree[0].name);
  return (
    <Space style={{ width: "100%" }} size={16} direction="vertical">
      <Modal
        destroyOnClose
        title={
          dataDetail?.id ? t("common.edit") : t("common.create")
        }
        open={isModalOpen}
        onCancel={() => {
          setModalOpen(false)
        }}
        footer={null}
        width={"60%"}
        closable={false}
        maskClosable={false}
      >

        <Formik
          enableReinitialize
          initialValues={{
            ...INITIAL_VAUES,
            ...dataDetail,
            educationDegreeId: dataDetail?.educationDegree?.id
          }}
          // initialValues={merge(INITIAL_VAUES, initialValues)}
          onSubmit={onSubmit}
          validationSchema={schema}

        >
          {({ values = {}, setFieldValue, submitForm, handleSubmit, resetForm, errors, isValid, dirty }) => {
            console.log("error", errors)
            return (
              <Form onFinish={submitForm}>
                {/* <Divider /> */}
                <Row gutter={[20, 20]}>
                  <Col span={12}>
                    <Input
                      required={true}
                      name="institute"
                      label={t('employee.institut')}
                      placeholder={t('fill-in-institute')}
                      size="large" />
                  </Col>
                  <Col span={12}>
                    <Select
                      required={true}
                      label={t('employee.education-degree')}
                      name="educationDegreeId"
                      placeholder={t('fill-in-education-degree')}
                      size="large"
                      options={educationDegreeOptions}
                    // onChange={(e) => {
                    //   console.log(e)
                    //   setFieldValue("educationDegreeId", e)
                    // }}
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      label={t('employee.faculty')}
                      name="faculty"
                      placeholder={t('employee.fill-in-faculty')}
                      size="large" />

                  </Col>
                  <Col span={12}>
                    {/* <Typography.Title level={5}>Graduated From*</Typography.Title> */}
                    {/* <RadioGroup label="Graduated From*" options={[]
                          // [{
                          //   label: "Local",
                          //   value: "a"
                          // }, {
                          //   label: "Aboard",
                          //   value: "b"
                          // }]
                        } defaultValue="a" size="large" buttonStyle="solid">
                        </RadioGroup> */}

                    <RadioGroup
                      // size="large"
                      required={true}
                      buttonStyle="solid"
                      optionType="button"
                      name="graduatedFrom"
                      label={t('employee.graduated-from')}
                      options={[
                        {
                          label: t('local-0'),
                          value: "local",
                        },
                        {
                          label: t('abroad'),
                          value: "aboard",
                        },
                      ]}
                      size="large"
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      label={t('employee.major-subject')}
                      name="majorSubject"
                      placeholder={t('fill-in-major-subject')}
                      size="large" />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      name="gpax"
                      label={t('employee.gpax')}
                      placeholder={t('fill-in-gpax')}
                      size="large"
                      step='0.5'
                      precision={2}
                      max={4}
                      min={0}
                      controls={false}
                      formatter={(value) => {
                        if (!value) return "";
                        const numericValue = parseFloat(value);
                        return numericValue.toFixed(2);
                      }}
                      parser={(value) => value?.replace(/[^\d.]/g, "")}
                      onKeyDown={(e) => {
                        const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                        const isNumberKey = e.key >= "0" && e.key <= "9";
                        const isDotKey = e.key === ".";

                        if (allowedKeys.includes(e.key)) return;

                        if (!isNumberKey && !isDotKey) {
                          e.preventDefault();
                          return;
                        }

                        const currentValue = e.target.value || "";
                        if (
                          (isDotKey && currentValue.includes(".")) ||
                          (isNumberKey &&
                            currentValue.includes(".") &&
                            currentValue.split(".")[1].length >= 2)
                        ) {
                          e.preventDefault();
                        }
                      }
                      }
                    />
                  </Col>

                  <Col span={12}>
                    <Space.Compact >
                      <Input
                        label={t('year-from')}
                        name="startDate"
                        placeholder={t('fill-in-year-start')}
                        size="large" />
                      <Input
                        label={t('employee.year-to')}
                        name="endDate"
                        placeholder={t('fill-in-year-end')}
                        size="large" />
                    </Space.Compact>

                  </Col>

                </Row>
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="cancelBtn"
                      type="default"
                      onClick={() => {
                        console.log("cancel");
                        setModalOpen(false);
                      }}
                      style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button htmlType="submit" type="primary"
                      style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: !isValid || !dirty ? "" : "var(--button-color)" }}
                      disabled={!isValid || !dirty}
                    >
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </Modal>
      {
        roles.includes("CREATE_EMPLOYEE|EMPLOYEE_INFO|EDUCATION") &&
        <Row justify="end">
          <Button onClick={(e) => {
            onCreate();
          }}
            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
            type="primary"

          >
            <Flex align="center" justify="center" gap={8}>
              <CreateIcon />
              {t("common.create")}
            </Flex>
          </Button>
        </Row>
      }

      <EmployeeInfoEducationTable
        isLoading={isLoading}
        dataSource={educationList}
        pagination={pagination}
        onChange={onChange}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Space >
  );
}

export default EmployeeInfoEducation;
